import Vue from "vue";
import Router from "vue-router";
import loginUtil from "@/util/loginUtil";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {mainMenu, mainNotMenu, notMain} from "./routerBuilder";

Vue.use(Router);

const routes = [
    notMain("登录", "login", "main/Login"),
    notMain("标签打印", "materialsTagsPrint", "Print/MaterialsTagsPrint"),
    notMain("标签打印", "productCardPrint", "Print/ProductCardPrint"),
    notMain("工单打印", "productOrderPrint", "Print/ProductOrderPrint"),
    notMain("工单打印", "productManageOrderPrint", "Print/ProductManageOrderPrint"),
    notMain("工单打印", "mergeOrderPrint", "Print/MergeOrderPrint"),
    // notMain("合并发料打印", "mergeIssuePrint", "Print/MergeIssuePrint"),
    notMain("领料单打印", "materialRequisitionPrint", "Print/MaterialRequisitionPrint"),
    notMain("出库单打印", "outboundOrderPrint", "Print/OutboundOrderPrint"),
    notMain("送货清单打印", "deliveryCompanyNotePrint", "Print/DeliveryCompanyNotePrint"),
    notMain("送货清单打印", "deliveryNotePrint", "Print/DeliveryNotePrint"),
    notMain("客户物料送货清单打印", "deliveryCustomerNotePrint", "Print/DeliveryCustomerNotePrint"),
    notMain("恒强送货清单打印", "deliveryCustomerHengQiangPrint", "Print/DeliveryCustomerHengQiangPrint"),
    notMain("终端客户送货单", "finalDeliveryNotePrint", "Print/FinalDeliveryNotePrint"),
    notMain("退货单打印", "deliveryBackCompanyNotePrint", "Print/DeliveryCompanyNotePrint"),
    notMain("退货单打印", "deliveryBackNotePrint", "Print/DeliveryNotePrint"),
    notMain("配货清单打印", "deliveryPrint", "Print/DeliveryPrint"),
    notMain("销售合同打印", "salesContractPrint", "Print/SalesContractPrint"),
    notMain("备品协议打印", "sparePartAgreementPrint", "Print/SparePartAgreementPrint"),
    notMain("销售订单打印", "salesOrderPrint", "Print/SalesOrderPrint"),
    notMain("产品销售框架合同打印", "productSalesContractPrint", "Print/ProductSalesContractPrint"),
    notMain("试用协议打印", "trialAgreementPrint", "Print/TrialAgreementPrint"),
    notMain("合同预览", "ClienContractPreview", "SalesManage/SalesClientContract/ClienContractPreview"),
    notMain("发料单打印", "storeIssuePrint", "Print/StoreIssuePrint"),
    notMain("入库单打印", "storageOrderPrint", "Print/StorageOrderPrint"),
    notMain("采购订单打印", "purchaseOrderPrint", "Print/PurchaseOrderPrint"),
    notMain("收货单打印", "orderReceivingPrint", "Print/OrderReceivingPrint"),
    notMain("条码打印", "orderReceivingCodePrint", "Print/OrderReceivingCodePrint"),
    notMain("维修签单打印", "repairWorkOrderPrint", "Print/RepairWorkOrderPrint"),
    notMain("返修品发货单打印", "returnMerchandiseDeliveryNotePrint", "Print/ReturnMerchandiseDeliveryNotePrint"),
    notMain("产品送修清单打印", "productRepairListPrint", "Print/ProductRepairListPrint"),
    notMain("售后维修报价清单打印", "repairRegistrationPrint", "Print/RepairRegistrationPrint"),
    notMain("载具条码打印", "vehiclePrint", "Print/VehiclePrint"),
    notMain("生产中心打印", "workCenterPrint", "Print/WorkCenterPrint"),
    notMain("仓库打印", "workHousePrint", "Print/WorkHousePrint"),
    notMain("员工编号打印", "employeePrint", "Print/EmployeePrint"),
    notMain("调拨单打印", "allotOrderPrint", "Print/AllotOrderPrint"),
    mainMenu("首页", "home", [{title: "首页", name: "Home", path: "/", componentPath: "main/Home", authIndex: 0}]),
    mainNotMenu([{title: "页面刷新", path: "/redirect/:path*", componentPath: "redirect/Redirect", authIndex: 0}]),
    mainNotMenu([
        {
            title: "合并发料打印",
            name: "mergeIssuePrint",
            path: "/MergeIssuePrint",
            componentPath: "Print/MergeIssuePrint",
            authIndex: 0,
        },
        {
            title: "发货单预览",
            name: "SalesDeliveryBillPreview",
            path: "/delivery",
            componentPath: "DeliveryManage/DeliveryBill/SalesDeliveryBillPreview",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "预约申请预览",
            name: "AppointmentPreview",
            path: "/Appointment",
            componentPath: "AfterSaleManage/AppointmentOrder/AppointmentPreview",
            authIndex: 631,
        },
    ]),
    mainNotMenu([
        {
            title: "预约申请分析",
            name: "AppointmentAnalysis",
            path: "/AppointmentAnalysis",
            componentPath: "AfterSaleManage/AppointmentOrder/AppointmentAnalysis",
            authIndex: 631,
        },
    ]),
    mainNotMenu([
        {
            title: "客诉信息预览",
            name: "ComplaintInfoPreview",
            path: "/ComplaintInfoPreview",
            componentPath: "AfterSaleManage/ComplaintInfo/ComplaintInfoPreview",
            authIndex: 631,
        },
    ]),
    mainNotMenu([
        {
            title: "更换申请预览",
            name: "ReplacementBillPreview",
            path: "/ReplacementBillPreview",
            componentPath: "AfterSaleManage/ReplacementBill/ReplacementBillPreview",
            authIndex: 631,
        },
    ]),
    mainNotMenu([
         {
            title: "生产维修预览",
            name: "RepairRegistrationSCPreview",
            path: "/RepairRegistrationSCPreview",
            componentPath: "maintenanceManage/repairRegistrationSC/RepairRegistrationSCPreview",
        },
    ]),
    mainNotMenu([
        {
            title: "售后维修预览",
            name: "RepairRegistrationCSPreview",
            path: "/RepairRegistrationCSPreview",
            componentPath: "maintenanceManage/repairRegistrationCS/RepairRegistrationCSPreview",
            authIndex: 591,
        },
    ]),
   
    mainNotMenu([
        {
            title: "来料检验预览",
            name: "InspectionIncomingPreview",
            path: "/InspectionIncomingPreview",
            componentPath: "inspection/inspectionIncoming/InspectionIncomingPreview",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "质量扣款预览",
            name: "AmercePreview",
            path: "/AmercePreview",
            componentPath: "inspection/Amerce/AmercePreview",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "出货检验预览",
            name: "ShipmentInspectPreview",
            path: "/ShipmentInspectPreview",
            componentPath: "inspection/shipmentInspect/ShipmentInspectPreview",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "要货计划预览",
            name: "PurchasePlanPreview",
            path: "/PurchasePlanPreview",
            componentPath: "PurchaseOrderManager/PurchasePlan/PurchasePlanPreview",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "开票申请预览",
            name: "InvoiceApplicationPreview",
            path: "/InvoiceApplicationPreview",
            componentPath: "SalesManage/InvoiceApplication/InvoiceApplicationPreview",
            authIndex: 0,
        },
        {
            title: "开票申请编辑",
            name: "InvoiceApplicationEdit",
            path: "/InvoiceApplicationEdit",
            componentPath: "SalesManage/InvoiceApplication/InvoiceApplicationEdit",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "对账管理预览",
            name: "ReconcileOrderDetail",
            path: "/ReconcileOrderDetail",
            componentPath: "PurchaseOrderManager/ReconcileOrder/ReconcileOrderDetail",
            authIndex: 0,
        },
    ]),
    mainNotMenu([
        {
            title: "预留单预览",
            name: "ReserveOrderPreview",
            path: "/ReserveOrderPreview",
            componentPath: "StoreManagement/ReserveOrder/ReserveOrderPreview",
            authIndex: 0,
        },
    ]),

    mainNotMenu([
        {
            title: "销单修改历史",
            name: "SalesOrderChangeHistory",
            path: "/SalesOrderChangeHistory",
            componentPath: "SalesManage/SalesOrderChange/SalesOrderChangeHistory",
            authIndex: 0,
        },
    ]),

    mainMenu("工作流", "workFlow", [
        {title: "对账管理待办", name: "ReconcileOrder", componentPath: "workFlow/ReconcileOrder", authIndex: 311},
        {title: "现场服务待办", name: "AppointmentApprove", componentPath: "workFlow/AppointmentApprove", authIndex: 635},
    ]),
    mainNotMenu([
        {
            title: "审批_",
            name: "Approval",
            path: "/approval",
            componentPath: "workFlow/Approval",
            authIndex: 0,
        },
    ]),
    mainMenu("销售管理", "SalesManage", [
        {
            title: "合同管理",
            name: "ClientContractList",
            componentPath: "SalesManage/SalesClientContract/ClientContractList",
            authIndex: 37,
        },
        {
            title: "合同明细管理",
            name: "ClientContractMaterial",
            componentPath: "SalesManage/SalesClientContract/ClientContractMaterial",
            authIndex: 756,
        },
        {
            title: "销售订单管理",
            name: "SalesOrderList",
            componentPath: "SalesManage/SalesOrder/SalesOrderList",
            authIndex: 3,
        },
        {
            title: "销售订单明细",
            name: "SalesOrderDetailList",
            componentPath: "SalesManage/SalesOrder/SalesOrderDetailList",
            authIndex: 330,
        },
        {
            title: "开票平台",
            name: "ToDoInvoiceList",
            componentPath: "SalesManage/InvoiceApplication/ToDoInvoiceList",
            authIndex: 239,
        },
        {
            title: "开票申请",
            name: "InvoiceListApplicationList",
            componentPath: "SalesManage/InvoiceApplication/InvoiceListApplicationList",
            authIndex: 240,
        },
        {
            title: "开票申请明细",
            name: "InvoiceApplicationDetailList",
            componentPath: "SalesManage/InvoiceApplicationDetail/InvoiceApplicationDetailList",
            authIndex: 60,
        },
        {
            title: "客户报价",
            name: "BusinessApplicationList",
            componentPath: "SalesManage/BusinessApplication/BusinessApplicationList",
            authIndex: 352,
        },
        {
            title: "销单变更",
            name: "SalesOrderChangeList",
            componentPath: "SalesManage/SalesOrderChange/SalesOrderChangeList",
            authIndex: 353,
        },
        {
            title: "销售预测",
            name: "SalesForecastList",
            componentPath: "SalesManage/SalesForecast/SalesForecastList",
            authIndex: 357,
        },
        {
            title: "商务待办",
            name: "DeliveryBillListToDoBySW",
            componentPath: "SalesManage/SalesOrder/DeliveryBillListToDoBySW",
            authIndex: 3,
        },
    ]),

    mainMenu("生产管理", "ProductionManagement", [
        {
            title: "生产工单",
            name: "ProductionOrder",
            componentPath: "ProductionManagement/ProductionOrder/ProductionOrderList",
            authIndex: 11,
        },
        {
            title: "通用扫描",
            name: "GeneralScan",
            componentPath: "ProductionManagement/ProductionScan/GeneralScan",
            authIndex: 469,
        },
        {
            title: "包装扫描",
            name: "PackScan",
            componentPath: "ProductionManagement/ProductionScan/PackScan",
            authIndex: 470,
        },
        {
            title: "包装扫描",
            name: "NoNeedSerialPackScan",
            componentPath: "ProductionManagement/ProductionScan/NoNeedSerialNoPackScan",
            authIndex: 470,
        },
        {
            title: "生产过程扫描",
            name: "ProductionScan",
            componentPath: "ProductionManagement/ProductionScan/ProductionScanIndex",
            authIndex: 24,
        },
        {
            title: "预加工开工扫描",
            name: "Preprocess",
            componentPath: "ProductionManagement/ProductionScan/Preprocess",
            authIndex: 471,
        },
        {
            title: "组装开工扫描",
            name: "Assembly",
            componentPath: "ProductionManagement/ProductionScan/Assembly",
            authIndex: 472,
        },
        {
            title: "关键元器件",
            name: "KeyComponents",
            componentPath: "ProductionManagement/ProductionScan/KeyComponents",
            authIndex: 473,
        },
        {
            title: "工单排产管理",
            name: "ProductionScheduleList",
            componentPath: "ProductionManagement/ProductionSchedule/ProductionScheduleList",
            authIndex: 316,
        },
        {
            title: "生产工单绑定条码",
            name: "ProductionOrderBindBarcode",
            componentPath: "ProductionManagement/ProductionOrderBindBarcode/ProductionOrderBindBarcode",
            authIndex: 68,
        },
    ]),
    mainMenu("扫描记录管理", "ScanRecordManagement", [
        {
            title: "生产组装工序",
            name: "ProductionAssemble",
            componentPath: "ProductionManagement/ProductionAssemble/ProductionAssembleList",
            authIndex: 748,
        },
        {
            title: "生产订单关键器件",
            name: "ComponentBinding",
            componentPath: "ProductionManagement/ComponentBinding/ComponentBindingList",
            authIndex: 55,
        },
        {
            title: "扫描记录",
            name: "OrderConfirmationRecordList",
            componentPath: "ScanRecordManagement/OrderConfirmationRecord/OrderConfirmationRecordList",
            authIndex: 760,
        },
    ]),
    mainMenu("采购管理", "PurchaseOrderManager", [
        {
            title: "采购订单",
            name: "PurchaseOrderList",
            componentPath: "PurchaseOrderManager/PurchaseOrder/PurchaseOrderList",
            authIndex: 399,
        },
        {
            title: "采购订单明细",
            name: "PurchaseOrderDetailListV2",
            componentPath: "PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailListV2",
            authIndex: 399,
        },
        {
            title: "创建送货单",
            name: "PurchaseOrderDetailList",
            componentPath: "PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailList",
            authIndex: 367,
        },
        {
            title: "创建送货单(要货)",
            name: "PurchaseOrderDetailListYH",
            componentPath: "PurchaseOrderManager/PurchaseOrder/PurchaseOrderDetailListYH",
            authIndex: 367,
        },
        {
            title: "送货单管理",
            name: "PurchaseReceiveList",
            componentPath: "PurchaseOrderManager/PurchaseReceiveList/PurchaseReceiveList",
            authIndex: 440,
        },
        {
            title: "创建对账单",
            name: "CreateReconcileOrder",
            componentPath: "PurchaseOrderManager/ReconcileOrder/CreateReconcileOrder",
            authIndex: 369,
        },
        {
            title: "对账单管理",
            name: "ReconcileOrderList",
            componentPath: "PurchaseOrderManager/ReconcileOrder/ReconcileOrderList",
            authIndex: 376,
        },
        {
            title: "创建生产要货计划",
            name: "PurchasePlanAdd",
            componentPath: "PurchaseOrderManager/PurchasePlan/PurchasePlanAdd",
            authIndex: 379,
        },
        {
            title: "创建发货要货计划",
            name: "DeliveryPlanAdd",
            componentPath: "PurchaseOrderManager/PurchasePlan/DeliveryPlanAdd",
            authIndex: 396,
        },
        {
            title: "要货计划管理",
            name: "PurchasePlanList",
            componentPath: "PurchaseOrderManager/PurchasePlan/PurchasePlanList",
            authIndex: 457,
        },
    ]),
    mainMenu("质量管理", "inspection", [
        {
            title: "改进调查单",
            name: "ImprovedSurveyList",
            componentPath: "ImprovedSurvey/ImprovedSurveyList",
            authIndex: 565,
        },
        {
            title: "来料检验",
            name: "InspectionIncomingList",
            componentPath: "inspection/inspectionIncoming/InspectionIncomingList",
            authIndex: 571,
        },
        {
            title: "供应商质量扣款",
            name: "AmerceList",
            componentPath: "inspection/Amerce/AmerceList",
            authIndex: 576,
        },
        {
            title: "过程检验",
            name: "ProcessExceptionList",
            componentPath: "inspection/processException/ProcessExceptionList",
            authIndex: 581,
        },
        {
            title: "出货检验",
            name: "ShipmentInspectList",
            componentPath: "inspection/shipmentInspect/ShipmentInspectList",
            authIndex: 586,
        },
    ]),
    mainMenu("维修管理", "inspection", [
        {
            title: "生产报修",
            name: "ProductionBGIndex",
            componentPath: "maintenanceManage/repairRegistrationBG/ProductionBGIndex",
            authIndex: 588,
        },
        {
            title: "待修清单",
            name: "FixToDoSCList",
            componentPath: "maintenanceManage/repairRegistrationBG/FixToDoSCList",
            authIndex: 588,
        },
        {
            title: "生产维修",
            name: "RepairRegistrationSCList",
            componentPath: "maintenanceManage/repairRegistrationSC/RepairRegistrationSCList",
            authIndex: 611,
        },
        {
            title: "售后接机",
            name: "RepairRegistrationJJList",
            componentPath: "maintenanceManage/repairRegistrationJJ/RepairRegistrationJJList",
            authIndex: 475,
        },
        {
            title: "售后签收",
            name: "RepairRegistrationQSList",
            componentPath: "maintenanceManage/repairRegistrationQS/RepairRegistrationQSList",
            authIndex: 592,
        },
        {
            title: "售后维修",
            name: "RepairRegistrationCSList",
            componentPath: "maintenanceManage/repairRegistrationCS/RepairRegistrationCSList",
            authIndex: 596,
        },

    ]),


    mainMenu("仓库管理", "StoreManagement", [
        {title: "预留单管理", name: "ReserveOrderList", componentPath: "StoreManagement/ReserveOrder/ReserveOrderList", authIndex: 499},
        {
            title: "出库单",
            name: "OutStockOrder",
            componentPath: "StoreManagement/OutStockOrder/OutStockOrderList",
            authIndex: 520,
        },
        {
            title: "入库单",
            name: "StorageOrder",
            componentPath: "StoreManagement/StorageOrder/StorageOrderIndex",
            authIndex: 521,
        },
        {title: "调拨单", name: "AllotOrder", componentPath: "StoreManagement/AllotOrder/AllotOrder", authIndex: 522},
        {
            title: "委外发料单",
            name: "MergeMaterialOrder",
            componentPath: "StoreManagement/MergeMaterialOrder/MergeOrderList",
            authIndex: 523,
        },
        {
            title: "委外发料单明细",
            name: "MergeMaterialOrderDetail",
            componentPath: "StoreManagement/MergeMaterialOrderDetail/MergeMaterialOrderDetailList",
            authIndex: 52,
        },

        {
            title: "物料库存查询",
            name: "SapMaterialWarehousing",
            componentPath: "StoreManagement/MaterialWarehousing/SapMaterialWarehousingList",
            authIndex: 552,
        },
        {title: "仓库预登记", name: "WarehousePreRegistrationList", componentPath: "StoreManagement/WarehousePreRegistration/WarehousePreRegistrationList", authIndex: 26},
        {title: "发货单明细序列", name: "DeliveryBillDetailSerialNoList", componentPath: "StoreManagement/DeliveryBillDetailSerialNo/DeliveryBillDetailSerialNoList", authIndex: 63},
    ]),

    mainMenu("发运管理", "DeliveryManage", [
        {
            title: "SAP发货单",
            name: "DeliveryBillList",
            componentPath: "DeliveryManage/DeliveryBill/DeliveryBillList",
            authIndex: 489,
        },
        {
            title: "SAP发货单明细",
            name: "DeliveryBillDetailList",
            componentPath: "DeliveryManage/DeliveryBillDetail/DeliveryBillDetailList",
            authIndex: 61,
        },
        {
            title: "仓库待办-发出",
            name: "DeliveryBillListToDo",
            componentPath: "DeliveryManage/DeliveryBill/DeliveryBillListToDoByCK",
            authIndex: 489,
        },
        {
            title: "仓库待办-退回",
            name: "DeliveryBillListToDoByBack",
            componentPath: "DeliveryManage/DeliveryBill/DeliveryBillListToDoByBack",
            authIndex: 48,
        },
    ]),

    mainMenu("售后管理", "AfterSaleManage", [
        {
            title: "客诉信息登记",
            name: "ComplaintInfo",
            componentPath: "AfterSaleManage/ComplaintInfo/ComplaintInfoList",
            authIndex: 554,
        },
        {
            title: "现场服务申请",
            name: "AppointmentOrder",
            componentPath: "AfterSaleManage/AppointmentOrder/AppointmentOrderList",
            authIndex: 630,
        },
        {
            title: "退换货申请",
            name: "ReplacementBillList",
            componentPath: "AfterSaleManage/ReplacementBill/ReplacementBillList",
            authIndex: 560,
        },
    ]),

    mainMenu("基本信息", "information", [
        {
            title: "供应商管理",
            name: "SupplierManage",
            componentPath: "information/SupplierManage/SupplierManageList",
            authIndex: 110,
        },
        {
            title: "客户管理",
            name: "CustomerList",
            componentPath: "information/Customer/CustomerList",
            authIndex: 100,
        },
        {
            title: "客户物料管理",
            name: "CustomerMaterialList",
            componentPath: "information/Customer/CustomerMaterialMappingList",
            authIndex: 105,
        },
        {
            title: "月结时间管理",
            name: "CloseBookDateList",
            componentPath: "information/CloseBookDate/CloseBookDateList",
            authIndex: 765,
        },
        {title: "部门管理", name: "DepartmentList", componentPath: "information/Department/DepartmentList", authIndex: 112},
        {title: "员工管理", name: "EmployeeList", componentPath: "information/Employee/EmployeeList", authIndex: 117},
        {title: "物料清单", name: "MaterialList", componentPath: "information/Material/MaterialList", authIndex: 123},
        {title: "价格清单", name: "MaterialPriceList", componentPath: "information/MaterialPrice/MaterialPriceList", authIndex: 17},
        {title: "价格申请列表", name: "MaterialPriceApplicationList", componentPath: "information/MaterialPrice/MaterialPriceApplicationList", authIndex: 626},
        {
            title: "物料类型",
            name: "MaterialTypeName",
            componentPath: "information/MaterialTypeName/MaterialTypeNameTree",
            authIndex: 627,
        },
        {title: "物料BOM", name: "BomList", componentPath: "information/BomManage/BomList", authIndex: 628},
        {title: "计量单位", name: "Unit", componentPath: "information/Unit/UnitList", authIndex: 637},
        {
            title: "条码规则",
            name: "BarCodeRules",
            componentPath: "information/BarCodeRules/BarCodeRulesList",
            authIndex: 636,
        },
        {
            title: "物料条码",
            name: "MaterialSnRule",
            componentPath: "information/MaterialSnRule/MaterialSnRuleList",
            authIndex: 629,
        },
        // {title: "区域管理", name: "District", componentPath: "information/District/DistrictList", authIndex: 65},
        // {title: "工厂信息", name: "Factory", componentPath: "information/Factory/FactoryList", authIndex: 162},
        // {title: "车间信息", name: "WorkShop", componentPath: "information/WorkShop/WorkShopList", authIndex: 168},
        // {title: "生产中心", name: "WorkCenter", componentPath: "information/WorkCenter/WorkCenterList", authIndex: 174},
        // {title: "工作单元", name: "WorkUnitManagement", componentPath: "information/WorkUnit/WorkUnitList", authIndex: 180},
        // {title: "技能管理", name: "Skill", componentPath: "information/Skill/SkillList", authIndex: 186},
        {title: "ESOP管理", name: "EsopList", componentPath: "information/ESOPV2/EsopList", authIndex: 192},
        {title: "ESOP详情", name: "EsopPreview", componentPath: "information/ESOPV2/EsopPreview", authIndex: 192},
        // {
        //     title: "工序类型",
        //     name: "ProcessTypeManagement",
        //     componentPath: "information/ProcessTypeManagement/ProcessTypeList",
        //     authIndex: 199,
        // },
        // {title: "工序管理", name: "Procedure", componentPath: "information/Procedure/ProcedureList", authIndex: 205},
        {title: "工艺路线", name: "SapBaseRouteList", componentPath: "information/SapBaseRoute/SapBaseRouteList", authIndex: 685},
        {title: "设备绑定工序", name: "DeviceBindingList", componentPath: "information/DeviceBinding/DeviceBindingList", authIndex: 212},
        // {
        //     title: "产品工艺",
        //     name: "RtRouteMaterial",
        //     componentPath: "information/RtRouteMaterial/RtRouteMaterialList",
        //     authIndex: 219,
        // },
        // {title: "载具配置", name: "Vehicle", componentPath: "information/Vehicle/VehicleList", authIndex: 76},
        // {title: "班组管理", name: "WorkerGroup", componentPath: "information/WorkerGroup/WorkerGroupList", authIndex: 86},
    ]),

    mainMenu("系统管理", "SystemInfo", [
        {title: "角色管理", name: "RoleList", componentPath: "SystemInfo/role/RoleList", authIndex: 252},
        {title: "用户管理", name: "UserList", componentPath: "SystemInfo/SystemUser/UserList", authIndex: 257},
        {title: "用户信息", name: "Profiles", componentPath: "SystemInfo/profiles/ProfilesList", authIndex: 263},
        {
            title: "菜单管理",
            name: "SystemFunction",
            componentPath: "SystemInfo/systemFunction/SystemFunctionTree",
            authIndex: 746,
        },
        {
            title: "编码规则",
            name: "EncodingRules",
            componentPath: "SystemInfo/EncodingRules/EncodingRulesList",
            authIndex: 279,
        },
    ]),
];

const router = new Router({
    base: process.env.BASE_URL,
    routes: routes,
});

const whiteUris = ["/login"]; // 白名单,无需登录即可访问

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.path.indexOf("/kb/") !== -1 ||
        to.path.indexOf("/ClienContractPreview") !== -1 ||
        whiteUris.indexOf(to.path) !== -1 ||
        loginUtil.isLogin()) {
        // 在白名单当中或者已经登录,放行
        next();
    } else {
        toLogin(to.fullPath);
    }
});

router.afterEach(() => {
    NProgress.done();
});

export const toLogin = () => {
    router.push({
        path: "/login",
    });
};

export {routes};
export default router;


